import { useStore } from '@/models/root-store';
import { TipKey } from '@/utils/constants';

import ShippingInfo from '../ShippingInfo/ShippingInfo';
import ToolTip from '../ToolTip/ToolTip';

const ProductShippingInfo = () => {
  const { generalStore } = useStore();
  const deliveryHeader = generalStore.getTipByKey(
    TipKey.RECURRING_DELIVERY_HEADING,
  );
  return (
    <div className="hidden items-center py-3 pl-6 font-interSemibold text-sm md:flex">
      <span className="mr-1">
        <ToolTip
          icon="/assets/icons/info-black.svg"
          contentStyle="rounded-2xl text-black bg-white shadow-2xl"
          containerStyle="absolute hidden flex-col group-hover:flex"
        >
          <ShippingInfo />
        </ToolTip>
      </span>
      <div dangerouslySetInnerHTML={{ __html: deliveryHeader }}></div>
    </div>
  );
};

export default ProductShippingInfo;
